// extracted by mini-css-extract-plugin
export default {"list":"plain-draggable-list_list__EU94o","placeHolderShimmer":"plain-draggable-list_placeHolderShimmer__Wx2BZ"};